/**
 * Application Insights bootstrap for the admin SPA.
 *
 * Same shape as apps/web/src/lib/telemetry.ts — kept as a per-app copy
 * so each SPA's bundle is independent and bundles cleanly without
 * cross-package resolution edge cases. Generated SDK type-defs are
 * shared automatically through the workspace package set.
 *
 * Stays a no-op when VITE_APPLICATIONINSIGHTS_CONNECTION_STRING is unset.
 */

import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsightsInstance: ApplicationInsights | null = null;

export function initTelemetry(): ApplicationInsights | null {
  if (appInsightsInstance) {
    return appInsightsInstance;
  }

  const connectionString = import.meta.env['VITE_APPLICATIONINSIGHTS_CONNECTION_STRING'];
  if (!connectionString) {
    return null;
  }

  const instance = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      distributedTracingMode: 2,
      autoTrackPageVisitTime: true,
      disableFetchTracking: false,
      enableUnhandledPromiseRejectionTracking: true,
      excludeRequestFromAutoTrackingPatterns: [/\/healthz$/],
    },
  });

  instance.loadAppInsights();
  instance.trackPageView();
  appInsightsInstance = instance;

  return instance;
}

export function appInsights(): ApplicationInsights | null {
  return appInsightsInstance;
}
